export const cookieConstants = {
  UTM_CAMPAIGN: 'rsUtmCampaign',
  UTM_TERM: 'rsUtmTerm',
  UTM_CONTENT: 'rsUtmContent',
  UTM_SOURCE: 'rsUtmSource',
  UTM_MEDIUM: 'rsUtmMedium',
  LANG: 'rsLangKey',
  SERVICE_INDUSTRY_TYPE: 'rsServIndustryType',
  LAWSON_DIVISION: 'rsLocLawson',
  INFOPRO_NUMBER: 'rsInfoProNumber',
  SERVICE_CODE: 'rsServiceCode',
  GOOGLE_CLICK_ID: 'gclid',
};
